module.exports = __webpack_public_path__ + "static/media/01_Forbes.eef082ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/01_Forbes.png
// module id = 529
// module chunks = 0